import { Button, Flex, Input, Space, Table, notification } from "antd";
import { useEffect, useState } from "react";
import axiosInstance from "../axios";
import dayjs from "dayjs";

const JobApplications = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dealIdFilter, setDealIdFilter] = useState("");
  const [mobileFilter, setMobileFilter] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const fetchData = async (page, limit, dealId = dealIdFilter, mobile = mobileFilter) => {
    setLoading(true);
    try {
      const params = { page, limit };
      if (dealId.trim()) params.dealId = dealId.trim();
      if (mobile.trim()) params.mobile = mobile.trim();

      const response = await axiosInstance.get("/v1/cre/job-applications", { params });
      const rows = response.data?.data || [];
      setData(
        rows.map((item) => ({
          ...item,
          submittedAt: item.created_at
            ? dayjs(item.created_at).format("DD MMM YYYY, hh:mm A")
            : "",
        })),
      );
      setPagination({
        current: page,
        pageSize: limit,
        total: response.data?.meta?.total || 0,
      });
    } catch (error) {
      notification.error({
        message: "Failed to load applications",
        description: "Could not fetch job applications list.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = () => {
    fetchData(1, pagination.pageSize, dealIdFilter, mobileFilter);
  };

  const handleReset = () => {
    setDealIdFilter("");
    setMobileFilter("");
    fetchData(1, pagination.pageSize, "", "");
  };

  const columns = [
    {
      title: "Deal ID",
      dataIndex: "dealings_id",
      key: "dealings_id",
      width: 100,
      render: (dealingsId) => (
        <a href={`/student/${dealingsId}`} target="_blank" rel="noopener noreferrer">
          {dealingsId}
        </a>
      ),
    },
    {
      title: "Job Title",
      dataIndex: "job_title",
      key: "job_title",
      ellipsis: true,
      render: (value) => value || "-",
    },
    {
      title: "First Name",
      dataIndex: "first_name",
      key: "first_name",
      width: 140,
    },
    {
      title: "Last Name",
      dataIndex: "last_name",
      key: "last_name",
      width: 140,
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      width: 100,
      render: (value) => value || "-",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      width: 130,
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      ellipsis: true,
      render: (value) => value || "-",
    },
    {
      title: "Submitted At",
      dataIndex: "submittedAt",
      key: "submittedAt",
      width: 180,
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Flex justify="space-between" align="center" style={{ marginBottom: 16 }} wrap="wrap" gap={12}>
        <h2 style={{ margin: 0 }}>Job Applications</h2>
        <Space wrap>
          <Input
            placeholder="Deal ID"
            value={dealIdFilter}
            onChange={(e) => setDealIdFilter(e.target.value)}
            style={{ width: 140 }}
            allowClear
          />
          <Input
            placeholder="Mobile"
            value={mobileFilter}
            onChange={(e) => setMobileFilter(e.target.value)}
            style={{ width: 160 }}
            allowClear
          />
          <Button type="primary" onClick={handleSearch}>
            Search
          </Button>
          <Button onClick={handleReset}>Reset</Button>
        </Space>
      </Flex>

      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={data}
        scroll={{ x: 1100 }}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          onChange: (page, pageSize) => fetchData(page, pageSize),
        }}
      />
    </div>
  );
};

export default JobApplications;
